import { useGetMyUser } from './useGetMyUser';

export function useMyUserId(): string {
  const { data } = useGetMyUser({
    options: {
      select: ({ user: { id } }) => id,
    },
  });
  return data;
}
